// freee OAuth ログイン URL の組み立て (クライアント専用)。
// 旧 NextAuth 時代の `/api/auth/signin` は存在しない URL のため、
// 再ログイン誘導は必ずこのヘルパーを経由して freee 認可画面へ飛ばす (#165)。

const FREEE_AUTH_URL =
  "https://accounts.secure.freee.co.jp/public_api/authorize";

export function getFreeeLoginUrl(): string {
  const params = new URLSearchParams({
    response_type: "code",
    client_id: process.env.NEXT_PUBLIC_FREEE_CLIENT_ID || "",
    redirect_uri: `${process.env.NEXT_PUBLIC_APP_URL}/api/auth/freee/callback`,
    prompt: "select_company",
    scope: "read write",
  });
  return `${FREEE_AUTH_URL}?${params}`;
}

export function redirectToFreeeLogin(): void {
  window.location.href = getFreeeLoginUrl();
}
